/*
 * Pipeline Theme - Custom JS
 * Lalueur - Swatch Toggle (6 visible + expand)
 */
(function() {
  window.addEventListener('load', function() {
    var swatches = document.querySelectorAll('radio-swatch');
    if (swatches.length <= 6) return;

    var parent = swatches[0].parentElement;

    // Create + button
    var btn = document.createElement('button');
    btn.className = 'swatch-toggle-btn';
    btn.textContent = '+';
    btn.type = 'button';

    // Create invisible row break after button
    var rowBreak = document.createElement('div');
    rowBreak.className = 'swatch-row-break';

    // Insert button after 6th swatch
    var seventhSwatch = swatches[6];
    parent.insertBefore(btn, seventhSwatch);
    parent.insertBefore(rowBreak, seventhSwatch);

    btn.addEventListener('click', function() {
      var expanded = btn.textContent === '−';
      swatches.forEach(function(swatch, i) {
        if (i >= 6) swatch.classList.toggle('swatch-expanded', !expanded);
      });
      btn.textContent = expanded ? '+' : '−';
    });
  });
})();

// Rename "Color" label to "Choose Your Finish"
window.addEventListener('load', function() {
  var labels = document.querySelectorAll('.radio_legend_label');
  labels.forEach(function(label) {
    if (label.textContent.trim().toLowerCase() === 'color') {
      label.textContent = 'Choose Your Finish';
    }
  });
});
